module.exports = __webpack_public_path__ + "img/BinaUmatLogo.96f34ec7.png";